import React from "react";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    height: "100%",
    margin: "0px",
  },
  content: {
    margin: "0px",
    height: "100%",
  },
  scrollBody: {
    margin: "0px",
    overflow: "auto",
    maxHeight: "100%"
  },
});

class PartialScrollContainer extends React.Component {
  
  render() {
    const { classes, className, children } = this.props;
    return <div className = { clsx(classes.root, className) } >
      <div className = { classes.content } >
        <div className = { classes.scrollBody } >
          { children }
        </div>
      </div>
    </div>
  }
}

PartialScrollContainer.propTypes = {
  children: PropTypes.node
};

export default withStyles(styles)(PartialScrollContainer);